module.exports = __webpack_public_path__ + "static/media/23.a63c8156.JPG";